module.exports = {
	model: {
		addressID: false,
		title: '',

		config: {
			relationContainer: 'children',
			relationName: 'client'
		},
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.buttons > button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target).closest('button');
				var fieldType = $target.data('fieldType');
				var buttonMode = $target.data('buttonMode');

				if(fieldType === 'showSelect'){
					self.showSelect(buttonMode);
				}
				else if(fieldType === 'showEdit'){
					self.showEdit();
				}
			}
		}
	},

	methods: {
		prepare: function(storage, isServer){
			var self = this;
			if(!isServer && !self.resourceData.initialized){
				self.closest('base_form_form', function(form){
					self.resourceData = ((form.resourceData.data || {})[self.model.config.relationContainer || 'children'] || {})[self.model.config.relationName || 'client'] || {};
					self.prepareMeta();
				});
			}
		},

		prepareMeta: function(){
			var self = this;
			self.resourceData.initialized = true;
			var data = self.resourceData.data || {};
			var attributes = data.attributes || {};

			self.model.addressID = attributes[data.primaryKey || 'id'];
			if(attributes.addressType === 'journalist' || !attributes.organisationName) {
				self.model.title = String((attributes.lastname || '') + ' ' + (attributes.firstname || '')).trim() || ''
			} else {
				self.model.title = attributes.organisationName
			}
		},

		/**
		 * shows a modal for address selection according to the given addressType.
		 *
		 * @param addressType			string - client | journalist | media
		 * @returns {promise}
		 */
		showSelect: function(addressType){
			if(addressType === 'client' || addressType === 'journalist' || addressType === 'media'){
				var baseActionKey = 'showSelect_address';

				return this.performAndStoreAction(
					baseActionKey + '_inEffect',
					this.prepareAction(baseActionKey, undefined, {
						selection: {
							addressType,
							connectionInclusive: true,
							hasActiveNewsletterEmail: null,
						},
					}),
					true
				);
			}
		},

		/**
		 * show tab to edit address
		 */
		showEdit: function(){
			var self = this;
			if(self.model.addressID){
				getComponent('artCrmController').showEdit('address', self.model.addressID, self.resourceData.data || {});
			}
		}
	},

	hooks: {
		/**
		 * handle modal select address decisions.
		 *
		 * @param $element
		 * @param options
		 */
		async onDecision($element, options){
			options = options || {};

			switch(options.decisionType){
				case 'addressSelected':
					this.resourceData = { data: options.addressData }
					await this.triggerClosest('onChildChanged', {
						fieldCode: 	this.model.fieldCode,
						value: 		options.addressID
					})
					let modal
					options.decisionComponent.closest('base_modal_modal', c => modal = c)
					if(modal){
						await modal.hide()
					}
					this.prepareMeta()
					this.refresh()

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide();
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		}
	}
};
